module.exports = __webpack_public_path__ + "c9e6ced6ee6d6f30cc5d3de2a811c27a.woff2";